import script from "./UpcomingMatchModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UpcomingMatchModal.vue?vue&type=script&setup=true&lang=js"

import "./UpcomingMatchModal.vue?vue&type=style&index=0&id=1f15fdd6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f15fdd6"]])

export default __exports__